import { trans } from "@mongez/localization";
import { Star, X } from "lucide-react";
import { useCallback, useEffect, useState } from "react";
import { MessagePinIcon } from "~/design-system/components/icons/social-icons";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "~/design-system/components/ui/tooltip";

export function GoogleReviewsButton() {
  const [isOpen, setIsOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  const handleOpen = useCallback(() => {
    setIsOpen(true);
    setIsClosing(false);
  }, []);

  const handleClose = useCallback(() => {
    setIsClosing(true);
    setTimeout(() => {
      setIsOpen(false);
      setIsClosing(false);
    }, 300);
  }, []);

  // Lock body scroll when popup is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  return (
    <>
      {/* Floating Button */}
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            onClick={handleOpen}
            className="group bg-primary-default fixed bottom-6 left-6 z-50 flex h-14 w-14 cursor-pointer items-center justify-center rounded-full shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-xl"
            aria-label={trans("googleReviews")}
          >
            <MessagePinIcon className="z-10 h-8 w-8  transition-transform duration-300 group-hover:rotate-12" />
          </button>
        </TooltipTrigger>
        <TooltipContent
          side="right"
          sideOffset={10}
          className="bg-primary-default border-none text-white"
        >
          {trans("googleReviews")}
        </TooltipContent>
      </Tooltip>

      {/* Popup Modal */}
      {isOpen && (
        <div
          className={`fixed inset-0 z-[9999] flex items-center justify-center p-4 ${
            isClosing ? "reviews-backdrop-out" : "reviews-backdrop-in"
          }`}
          onClick={handleClose}
        >
          {/* Modal Content */}
          <div
            className={`relative flex h-[85vh] w-full max-w-6xl flex-col overflow-hidden rounded-2xl bg-white shadow-2xl ${
              isClosing ? "reviews-modal-out" : "reviews-modal-in"
            }`}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="border-primary-200 from-primary-default to-primary-700 flex items-center justify-between border-b bg-gradient-to-r px-6 py-4">
              <div className="flex items-center gap-3">
                <div className="flex h-9 w-9 items-center justify-center rounded-full bg-white/20">
                  <Star className="h-5 w-5 fill-white text-white" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-white">
                    Customer Reviews
                  </h3>
                  <p className="text-xs text-white/80">
                    See what our customers say about us
                  </p>
                </div>
              </div>
              <button
                onClick={handleClose}
                className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-white/20 text-white transition-all duration-200 hover:bg-white/30"
                aria-label="Close reviews"
              >
                <X className="h-4 w-4" />
              </button>
            </div>

            {/* Iframe Container */}
            <div className="bg-secondary-50 flex-1 overflow-hidden">
              <iframe
                src="https://widgets.sociablekit.com/google-reviews/iframe/25654906"
                frameBorder="0"
                width="100%"
                height="100%"
                title="Google Reviews"
                className="h-full w-full"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
